<template>
  <div class="_content">
    <div v-if="!shopNo">
      <h2 class="fontWeight">小鲲车服指定服务网点合作协议</h2>

      <p class="fontWeight margin">协议适用主体范围</p>
      <div class="text indent2">
        本协议是商户（以下可称为“您”）与小鲲车服（以下简称“我司”）之间关于汽车维修保养、汽车美容服务之相关合作所定立的协议，依据《中华人民共和国合同法》等有关法律、法规的规定，经友好、平等协商，双方现达成如下内容，以资遵行：
      </div>

      <p class="fontWeight margin">合作期限</p>
      <div class="text">
        <p>
          双方的合作期限为两（2）年，从首次同意该协议时间开始计算（“首次合作期”）。
        </p>
        <p>
          首次合作期届满前三十（30）日，若双方均未提出本协议不再续期，则双方合作期限自动续展一（1）年（“合作展期”）；
        </p>
        <p>
          合作展期届满前三十（30）日，若双方均选择继续合作，则应另行签订书面协议；除非双方另有约定，本协议所有条款在合作展期内继续有效。
        </p>
        <p>
          合作期限（包括首次合作期、合作展期）届满前，我司有权视市场、您履约情况及其他各方面因素，单方决定是否续约。
        </p>
      </div>

      <p class="fontWeight margin">合作内容</p>
      <div class="text">
        <p class="fontWeight">双方合作的服务项目有：</p>
        <p>
          <span class="fontWeight">汽车保养维修</span
          >包括但不限于：机油更换、滤清器更换、喷漆等。
        </p>
        <p>
          <span class="fontWeight">汽车美容服务项目</span
          >包括但不限于：普通洗车、精细洗车、打蜡等。
        </p>
        <p>
          双方合作内容均不包含汽车配件产品销售，您须接受我司客户自带汽车配产品由您提供服务。
        </p>
        <p>
          您为我司客户提供服务所必需的设备、工具、耗材等由您自行准备、提供，该等设备、工具、耗材等应符合我司要求和相应国家标注或行业标准的要求。
        </p>
        <p>
          经我司客户同意，您可以向我司客户推销、提供其自行采购第三方产品（该等产品须不会替代我司客户已从我司购买的产品），及提供安装服务，与我司无关，由您自行承担所有责任。
        </p>
        <p class="fontWeight">系统使用</p>
        <p>小鲲门店商户系统</p>
        <p>
          我司在“小鲲车服”公众号中为您开放接口及登录授权，并为您提供系统使用培训服务。您应安排专人熟练使用该系统，并使用该业务系统接受我司派单。
        </p>
        <p class="fontWeight">营业时间</p>
        <p>
          您须应保证在可以接受我司系统派单的时间内正常营业。如您实在无法在法定节假日进行营业，您需明确提前告知我司停止向您派单。
        </p>
        <p class="fontWeight">营销与推广</p>
        <p>
          我司可以对您店铺提供营销支持，您可以选择在我司平台通过展示、系统推荐、营销活动策划、广告、市场推广等各类营销方法宣传您店铺及相关活动。
        </p>
      </div>

      <p class="fontWeight margin">服务流程</p>
      <div class="text">
        <p class="fontWeight">汽车美容服务流程</p>
        <p>
          客户在我司平台及我司授权的第三方合作平台获得汽车美容服务产品或者进行预约后，我司将向客户发出服务权凭证或服务验证码，并将预约信息通知您。
        </p>
        <p>
          您根据我司的通知、客户所持的服务权凭证或者服务验证码，为客户安排经验丰富的工作人员提供汽车美容服务。您为客户提供安汽车美容服务完毕后，根据客户提供的服务权凭证或者服务验证码，在我司“小鲲车服公众号”中结算服务费。
        </p>
      </div>

      <p class="fontWeight margin">服务标准与要求</p>
      <div class="text">
        <p class="fontWeight">服务重点要求：</p>
        <p>
          您应熟练、准确使用我司业务系统以保证服务质量。我司将不定期对您进行业务系统使用熟练度抽查。您连续三（3）次不合格，我司有权终止合作。
        </p>
        <p>
          您根据我司的检测/安装单为我司客户提供安装服务，不得替换其它任何产品；在我司未知情且未授权的情况下，您替代其它任何产品导致的损失由您全部承担。
        </p>
        <p>
          您如经我司客户同意，向我司客户推销、提供其自行采购的第三方产品（该等产品须不会替代我司客户已从我司购买的产品），必须确保产品质量，并且对所提供的产品质量承担全部责任。我司不承担因安装非我司货品所导致的任何风险和责任。
        </p>
        <p>
          在协议有效期内，您无正当理由不得拒绝为我司客户提供相应服务。如因您无正当理由拒绝提供服务而产生的一切损失由您全部承担，且我司有权因您拒绝为我司客户提供服务而终止与您的合作关系。
        </p>
      </div>

      <p class="fontWeight margin">客户投诉与处理</p>
      <div class="text">
        <p>
          您有义务竭力为客户提供优质满意的服务体验，不得因为推销店里产品及其他服务造成客户不满及投诉。确实因您问题导致的服务的投诉累计≥3次，我司有权终止与其的合作关系。
        </p>
        <p>
          上述情况下，若客户在向我司投诉的过程中索赔或要求我司给予解决方案，我司因此先行给予客户的任何赔付、赔偿、补偿、赠与等，均应由您承担。我司有权在您的保证金或结算款项中进行扣除。
        </p>
      </div>

      <p class="fontWeight margin">费用结算</p>
      <div class="text">
        <p class="fontWeight">服务费</p>
        <p>
          服务费系指您为我司客户提供符合本协议约定的标准、要求的汽车配件、设备安装及美容服务后，我司应支付给您的服务费。
        </p>
        <p class="fontWeight">对账与结算</p>
        <p>
          我司和您约定每月的一个固定日作为对帐日（“约定对账日”，若遇到周末、法定节假日予以相应顺延），用以核对您上个月的服务费，并在对帐日当天完成当期对帐。对账完成后<span
            class="decoration"
          >
            7 </span
          >个工作日内，您应向我司提供合法的、相应金额的增值税发票，我司在收到该等增值税发票后<span
            class="decoration"
          >
            7 </span
          >个工作日内将相应服务费支付到您指定账户。
        </p>
        <p>您指定银行账户为：</p>
        <p>以双方协定的账户为准。</p>
      </div>

      <p class="fontWeight margin">禁止恶意刷单与舞弊</p>
      <div class="text">
        <p>
          对于我司推出的优惠券或其他优惠产品和/或服务，目的是为回馈车主，扩大用户群，您不得直接参与购买该等产品和/或服务。如您存在或参与恶意刷单、作弊等行为，一经我司查实、认定，我司有权立即终止本协议，
        </p>
        <p class="fontWeight">恶意刷单、舞弊行为包括但不限于：</p>
        <p>
          我司随机抽取涉嫌恶意刷单、舞弊的注册手机号码在不同时段进行拨打，同一号码在不同时段拨打总计三（3）次后仍无法与手机号码所有人取得联系的，包括但不限于：手机通话显示“已停机”、“已关机”、“无人接听”、“无法接通”、“拨打号码不存在”等；
        </p>
        <p>
          尽管与涉嫌恶意刷单、舞弊的注册手机号码所有人取得了联系，但我司发现该手机号码所有人并未在我司平台及我司授权的第三方合作平台使用该手机号码注册为我司用户/客户，亦未授权其他人使用该手机号码注册为我司用户/客户；
        </p>
        <p>
          其他证明涉嫌恶意刷单、舞弊的注册手机号码所有人并未注册或授权注册成为我司用户/客户的情形。
        </p>
        <p>
          如出现上述涉嫌恶意刷单、舞弊行为的比例达到我司抽取号码比例的百分之十（10%），我司有权认定您存在或参与恶意刷单、舞弊行为。
        </p>
      </div>

      <p class="fontWeight margin">保密条款</p>
      <div class="text">
        <p>
          双方的交易或合作关系亦视为保密信息。双方应对本协议的存在、协议协商过程中的报价和最终成交价，以及双方之间已有、正在进行或者未来的交易或者合作关系承担保密义务。非经对方书面同意，双方不得向任何第三方（不包括因工作需要而接触保密信息的员工、财务审计机构、顾问、律师、服务地点物业管理部门之必要登记、公安部门之必要登记）披露。
        </p>
        <p>
          一方在本协议有效期内违反上述规定，另一方有权立即无条件终止本协议，并享有追究违约方的违约责任的权利。
        </p>
      </div>

      <p class="fontWeight margin">反贪污、反商业贿赂</p>
      <div class="text">
        <p>
          双方均申明并同意，过去、现在和将来在与对方品牌有关的业务和合作的过程中，严守中国有关反贪污腐败、反商业贿赂方面法律、法规的规定，杜绝提供、承诺给予、给予、同意接受或接受任何非法贿赂、回扣、回报、影响付款、返利或其他非法支付金钱、有价物品、卡券或任何利益（包括疏通费）等任何违反这些法律、法规的行为。
        </p>
        <p>
          如果一方或其分公司、集团公司、分包商、代理或代表违反本条规定，和/或因涉及或从事任何可能构成反贿赂法下犯罪的行为被指控或被调查，守约方有权单方面立即终止本协议而不承担任何违约或赔偿责任。如前述任何行为给守约方造成任何损失的，守约方保留追究法律责任和要求赔偿损失的权利。
        </p>
      </div>

      <p class="fontWeight margin">适用法律与争议解决</p>
      <div class="text">
        <p>
          本协议的成立、生效、解释及履行等各方面均适用中华人民共和国现行及未来生效的法律，并依之解释。
        </p>
        <p>
          任何因本协议或者本协议的履行而引发的争议，双方应首先采取友好协商的方式解决该争议；如协商不成，双方同意向我司住所地的有管辖权的人民法院提起诉讼。
        </p>
        <p>
          当因一方违反本协议规定而起争议时，除须承担违约或者侵权责任外，违约方/侵权方还需承担守约方就该等争议主张权利的相关费用，包括但不限于诉讼费用、律师费用、调查取证费用、差旅费用。
        </p>
      </div>

      <p class="fontWeight margin">其他约定</p>
      <div class="text">
        <p>
          双方在此认可，双方均为独立履行本协议的法人主体，自担风险和费用履行本协议；双方之间不因本协议的存在、履行而存在或产生任何合伙、合营、代理或雇佣关系。在任何涉及第三方的活动中，除本协议有明确规定外，本协议的任何一方均无权代表另一方行事，亦不得以本协议另一方之名义与其他第三方签署任何协议，除非事先有书面授权。
        </p>
        <p>本协议自您同意之日起生效。</p>
        <p class="fontWeight margin">
          汽车美容服务内容和服务费以最终您和本司协商的项目和价格为准。
        </p>
      </div>
    </div>
    <!--  -->
    <div v-else>
      <h2 class="fontWeight">小鲲车服指定服务网点合作协议</h2>

      <p class="fontWeight margin">协议适用主体范围</p>
      <div class="text indent2">
        本协议是商户（以下可称为“您”）<span class="fontWeight">{{
          shopInfo.name
        }}</span
        >与<span class="fontWeight">杭州小鲲科技有限公司（小鲲车服）</span
        >（以下简称“我司”）之间关于汽车维修保养、汽车美容服务之相关合作所定立的协议，依据《中华人民共和国合同法》等有关法律、法规的规定，经友好、平等协商，双方现达成如下内容，以资遵行：
      </div>

      <p class="fontWeight margin">合作期限</p>
      <div class="text">
        <p>
          双方的合作期限为两（2）年，从首次同意该协议时间开始计算（“首次合作期”）。
        </p>
        <p>
          首次合作期届满前三十（30）日，若双方均未提出本协议不再续期，则双方合作期限自动续展一（1）年（“合作展期”）；
        </p>
        <p>
          合作展期届满前三十（30）日，若双方均选择继续合作，则应另行签订书面协议；除非双方另有约定，本协议所有条款在合作展期内继续有效。
        </p>
        <p>
          合作期限（包括首次合作期、合作展期）届满前，我司有权视市场、您履约情况及其他各方面因素，单方决定是否续约。
        </p>
      </div>

      <p class="fontWeight margin">合作内容</p>
      <div class="text">
        <p class="fontWeight">双方合作的服务项目有：</p>
        <p>
          <span class="fontWeight">汽车保养维修</span
          >包括但不限于：机油更换、滤清器更换、喷漆等。
        </p>
        <p>
          <span class="fontWeight">汽车美容服务项目</span
          >包括但不限于：普通洗车、精细洗车、打蜡等。
        </p>
        <p>
          双方合作内容均不包含汽车配件产品销售，您须接受我司客户自带汽车配产品由您提供服务。
        </p>
        <p>
          您为我司客户提供服务所必需的设备、工具、耗材等由您自行准备、提供，该等设备、工具、耗材等应符合我司要求和相应国家标注或行业标准的要求。
        </p>
        <p>
          经我司客户同意，您可以向我司客户推销、提供其自行采购第三方产品（该等产品须不会替代我司客户已从我司购买的产品），及提供安装服务，与我司无关，由您自行承担所有责任。
        </p>
        <p class="fontWeight">系统使用</p>
        <p>小鲲门店商户系统</p>
        <p>
          我司在“小鲲车服”公众号中为您开放接口及登录授权，并为您提供系统使用培训服务。您应安排专人熟练使用该系统，并使用该业务系统接受我司派单。
        </p>
        <p class="fontWeight">营业时间</p>
        <p>
          您须应保证在可以接受我司系统派单的时间内正常营业。如您实在无法在法定节假日进行营业，您需明确提前告知我司停止向您派单。
        </p>
        <p class="fontWeight">营销与推广</p>
        <p>
          我司可以对您店铺提供营销支持，您可以选择在我司平台通过展示、系统推荐、营销活动策划、广告、市场推广等各类营销方法宣传您店铺及相关活动。
        </p>
      </div>

      <p class="fontWeight margin">服务流程</p>
      <div class="text">
        <p class="fontWeight">汽车美容服务流程</p>
        <p>
          客户在我司平台及我司授权的第三方合作平台获得汽车美容服务产品或者进行预约后，我司将向客户发出服务权凭证或服务验证码，并将预约信息通知您。
        </p>
        <p>
          您根据我司的通知、客户所持的服务权凭证或者服务验证码，为客户安排经验丰富的工作人员提供汽车美容服务。您为客户提供安汽车美容服务完毕后，根据客户提供的服务权凭证或者服务验证码，在我司“小鲲车服公众号”中结算服务费。
        </p>
      </div>

      <p class="fontWeight margin">服务标准与要求</p>
      <div class="text">
        <p class="fontWeight">服务重点要求：</p>
        <p>
          您应熟练、准确使用我司业务系统以保证服务质量。我司将不定期对您进行业务系统使用熟练度抽查。您连续三（3）次不合格，我司有权终止合作。
        </p>
        <p>
          您根据我司的检测/安装单为我司客户提供安装服务，不得替换其它任何产品；在我司未知情且未授权的情况下，您替代其它任何产品导致的损失由您全部承担。
        </p>
        <p>
          您如经我司客户同意，向我司客户推销、提供其自行采购的第三方产品（该等产品须不会替代我司客户已从我司购买的产品），必须确保产品质量，并且对所提供的产品质量承担全部责任。我司不承担因安装非我司货品所导致的任何风险和责任。
        </p>
        <p>
          在协议有效期内，您无正当理由不得拒绝为我司客户提供相应服务。如因您无正当理由拒绝提供服务而产生的一切损失由您全部承担，且我司有权因您拒绝为我司客户提供服务而终止与您的合作关系。
        </p>
      </div>

      <p class="fontWeight margin">客户投诉与处理</p>
      <div class="text">
        <p>
          您有义务竭力为客户提供优质满意的服务体验，不得因为推销店里产品及其他服务造成客户不满及投诉。确实因您问题导致的服务的投诉累计≥3次，我司有权终止与其的合作关系。
        </p>
        <p>
          上述情况下，若客户在向我司投诉的过程中索赔或要求我司给予解决方案，我司因此先行给予客户的任何赔付、赔偿、补偿、赠与等，均应由您承担。我司有权在您的保证金或结算款项中进行扣除。
        </p>
      </div>

      <p class="fontWeight margin">费用结算</p>
      <div class="text">
        <p class="fontWeight">服务费</p>
        <p>
          服务费系指您为我司客户提供符合本协议约定的标准、要求的汽车配件、设备安装及美容服务后，我司应支付给您的服务费。
        </p>

        <table
          border="1"
          cellspacing="1px"
          bordercolor="#254389"
          cellpadding="0"
          style="border-collapse: collapse; width: 100%"
        >
          <tr align="center" height="30">
            <th style="width: 10.33%">序号</th>
            <th style="width: 53.33%">签约服务</th>
            <th style="width: 33.33%">签约价格</th>
          </tr>
          <tr
            align="center"
            height="30"
            v-for="(item, index) in shopSignServviceList"
            :key="index"
          >
            <td>{{ index * 1 + 1 }}</td>
            <td>{{ item.signService }}</td>
            <td>{{ item.signPrice }}</td>
          </tr>
        </table>
        <br />

        <p class="fontWeight">对账与结算</p>
        <p>
          我司和您约定每月的一个固定日作为对帐日（“约定对账日”，若遇到周末、法定节假日予以相应顺延），用以核对您上个月的服务费，并在对帐日当天完成当期对帐。对账完成后<span
            class="decoration"
          >
            7 </span
          >个工作日内，您应向我司提供合法的、相应金额的增值税发票，我司在收到该等增值税发票后<span
            class="decoration"
          >
            7 </span
          >个工作日内将相应服务费支付到您指定账户。
        </p>
        <p>您指定银行账户为：</p>

        <p class="fontWeight">开户银行：{{ shopBankCardInfos.bankName }}</p>

        <p class="fontWeight">
          支行信息：{{ shopBankCardInfos.bankBranchName }}
        </p>

        <p class="fontWeight">账户名称：{{ shopBankCardInfos.bankAccount }}</p>

        <p class="fontWeight">
          银行账号：{{ shopBankCardInfos.bankAccountName }}
        </p>

        <p class="fontWeight">
          联行号：{{ shopBankCardInfos.bankAccountNumber }}
        </p>
      </div>

      <p class="fontWeight margin">禁止恶意刷单与舞弊</p>
      <div class="text">
        <p>
          对于我司推出的优惠券或其他优惠产品和/或服务，目的是为回馈车主，扩大用户群，您不得直接参与购买该等产品和/或服务。如您存在或参与恶意刷单、作弊等行为，一经我司查实、认定，我司有权立即终止本协议，
        </p>
        <p class="fontWeight">恶意刷单、舞弊行为包括但不限于：</p>
        <p>
          我司随机抽取涉嫌恶意刷单、舞弊的注册手机号码在不同时段进行拨打，同一号码在不同时段拨打总计三（3）次后仍无法与手机号码所有人取得联系的，包括但不限于：手机通话显示“已停机”、“已关机”、“无人接听”、“无法接通”、“拨打号码不存在”等；
        </p>
        <p>
          尽管与涉嫌恶意刷单、舞弊的注册手机号码所有人取得了联系，但我司发现该手机号码所有人并未在我司平台及我司授权的第三方合作平台使用该手机号码注册为我司用户/客户，亦未授权其他人使用该手机号码注册为我司用户/客户；
        </p>
        <p>
          其他证明涉嫌恶意刷单、舞弊的注册手机号码所有人并未注册或授权注册成为我司用户/客户的情形。
        </p>
        <p>
          如出现上述涉嫌恶意刷单、舞弊行为的比例达到我司抽取号码比例的百分之十（10%），我司有权认定您存在或参与恶意刷单、舞弊行为。
        </p>
      </div>

      <p class="fontWeight margin">保密条款</p>
      <div class="text">
        <p>
          双方的交易或合作关系亦视为保密信息。双方应对本协议的存在、协议协商过程中的报价和最终成交价，以及双方之间已有、正在进行或者未来的交易或者合作关系承担保密义务。非经对方书面同意，双方不得向任何第三方（不包括因工作需要而接触保密信息的员工、财务审计机构、顾问、律师、服务地点物业管理部门之必要登记、公安部门之必要登记）披露。
        </p>
        <p>
          一方在本协议有效期内违反上述规定，另一方有权立即无条件终止本协议，并享有追究违约方的违约责任的权利。
        </p>
      </div>

      <p class="fontWeight margin">反贪污、反商业贿赂</p>
      <div class="text">
        <p>
          双方均申明并同意，过去、现在和将来在与对方品牌有关的业务和合作的过程中，严守中国有关反贪污腐败、反商业贿赂方面法律、法规的规定，杜绝提供、承诺给予、给予、同意接受或接受任何非法贿赂、回扣、回报、影响付款、返利或其他非法支付金钱、有价物品、卡券或任何利益（包括疏通费）等任何违反这些法律、法规的行为。
        </p>
        <p>
          如果一方或其分公司、集团公司、分包商、代理或代表违反本条规定，和/或因涉及或从事任何可能构成反贿赂法下犯罪的行为被指控或被调查，守约方有权单方面立即终止本协议而不承担任何违约或赔偿责任。如前述任何行为给守约方造成任何损失的，守约方保留追究法律责任和要求赔偿损失的权利。
        </p>
      </div>

      <p class="fontWeight margin">适用法律与争议解决</p>
      <div class="text">
        <p>
          本协议的成立、生效、解释及履行等各方面均适用中华人民共和国现行及未来生效的法律，并依之解释。
        </p>
        <p>
          任何因本协议或者本协议的履行而引发的争议，双方应首先采取友好协商的方式解决该争议；如协商不成，双方同意向我司住所地的有管辖权的人民法院提起诉讼。
        </p>
        <p>
          当因一方违反本协议规定而起争议时，除须承担违约或者侵权责任外，违约方/侵权方还需承担守约方就该等争议主张权利的相关费用，包括但不限于诉讼费用、律师费用、调查取证费用、差旅费用。
        </p>
      </div>

      <p class="fontWeight margin">其他约定</p>
      <div class="text">
        <p>
          双方在此认可，双方均为独立履行本协议的法人主体，自担风险和费用履行本协议；双方之间不因本协议的存在、履行而存在或产生任何合伙、合营、代理或雇佣关系。在任何涉及第三方的活动中，除本协议有明确规定外，本协议的任何一方均无权代表另一方行事，亦不得以本协议另一方之名义与其他第三方签署任何协议，除非事先有书面授权。
        </p>
        <p>本协议自您同意之日起生效。</p>
        <div class="shop-flex">
          <div class="flex-row">
            <p>
              <span class="span1">商户：</span
              ><span class="span2">{{ shopInfo.name }}</span>
            </p>
            <p>
              <span class="span1">平台名称：</span
              ><span class="span2">杭州小鲲科技有限公司（小鲲车服）</span>
            </p>
          </div>
            <div class="flex-row">
            <p>
              <span class="span1">商户签字：</span
              ><img class="sing" :src="sing" alt="" />
            </p>
            <p>
              <span class="span1">平台盖章：</span
              ><img class="chapter" :src="chapter" alt="" />
            </p>
          </div>
                  <div class="flex-row">
            <p>
              <span class="span1">日期：</span
              ><span class="span2">{{ shopInfo.createdTime }}</span>
            </p>
            <p>
               <span class="span1">日期：</span
              ><span class="span2">{{ shopInfo.createdTime }}</span>
            </p>
          </div>


          <!-- <div class="ft-w">
            <p>
              <span class="span1">商户：</span
              ><span class="span2">{{shopInfo.name}}</span>
            </p>
            <p>
              <span>商户签字：</span><img class="sing" :src="sing" alt="" />
            </p>
            <p><span class="span1">日期：</span><span class="span2">{{shopInfo.createdTime}}</span></p>
          </div>
          <div class="ft-w">
            <p>
              <span class="span1">平台名称：</span><span class="span2">杭州小鲲科技有限公司（小鲲车服）</span>
            </p>
            <p>
              <span>平台盖章：</span
              ><img class="chapter" :src="chapter" alt="" />
            </p>
            <p><span class="span1">日期：</span><span class="span2">{{shopInfo.createdTime}}</span></p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/configs/config";
export default {
  data() {
    return {
      shopNo: tuhu.getParam("shopNo") || null,
      sing: require("../../imgs/images/sing.png"),
      chapter: require("../../imgs/images/chapter.png"),
      shopBankCardInfos: {},
      shopInfo: {},
      shopSignServviceList: [],
    };
  },
  mounted() {
    if (this.shopNo) {
      this.getAgreementInfo();
    }
  },
  methods: {
    async getAgreementInfo() {
      let params = {
        shopId: this.shopNo,
      };
      let res = await tuhu.fetch(`${config.apis.GET_AGREEMERT_INFO}`, {
        method: "post",
        body: JSON.stringify(params || ""),
      });
      if (res.code === '200') {
        this.shopBankCardInfos = res.data.shopBankCardInfos;
        this.shopInfo = res.data.shopInfo;
        this.shopSignServviceList = res.data.shopSignServviceList;
      } else {
        tuhu.toast(res.message || "网络错误");
      }
    },
  },
};
</script>

<style lang="less" scoped>
._content {
  background: #fff;
  padding: 0.75rem 0.5rem;
  p {
    line-height: 1.5;
  }
  h2 {
    text-align: center;
  }
  .decoration {
    text-decoration: underline;
  }
  .fontWeight {
    font-weight: 600;
  }
  .text {
    padding: 0 0 0 1.25rem;
    position: relative;
  }
  .indent2 {
    text-indent: 2em;
  }
  .indent4 {
    text-indent: 4em;
  }
  .margin {
    margin: 0.3rem 0;
  }
}
.shop-flex {

  margin-top: 0.2rem;
    width: 100%;
    .flex-row{
    display: flex;
    justify-content: space-between;
    width: 100%;
    p{
      font-weight: 600;
      width: 49%;
      display: flex;
      line-height: 1.2rem;
      .span1{
        white-space: nowrap;
      }

      .sing{
        height: 1rem;
        width: 4rem;
      }
      .chapter{
        width: 5.5rem;
        height:5.5rem;
        position: absolute;
      bottom: 0;
      right: 0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/common/agreement.vue